<template>
  <div class="message-box">
    <div class="content-center">
      <p
        v-if="message.message === 'action.ticketAssign'"
        class="content-message"
      >
        {{ $t(message.message, { operator: message.localizeValue.name }) }}
      </p>

      <p
        v-else-if="message.message === 'action.ticketStatus'"
        class="content-message"
      >
        {{
          $t(message.message, {
            operator: message.localizeValue.name,
            status: $t(getStatusLabel(message.status)),
          })
        }}
      </p>

      <div class="content-detail">
        <p>{{ message.createdAt | formatShortDate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      default: () => ({
        message: "something",
        createdAt: "2021-05-01T00:00:00.000Z",
        localizeValue: {
          name: {
            type: String,
            default: "Socket",
          },
        },
      }),
    },
  },
  setup() {
    function getStatusLabel(statusCode) {
      const status = {
        0: "",
        1: "ticket.open",
        2: "ticket.resolved",
        3: "status.pending",
      };
      return status[statusCode];
    }
    return { getStatusLabel };
  },
};
</script>

<style lang="scss" scoped>
.message-box {
  display: flex;
  justify-content: center;

  .content-center {
    text-align: center;
  }

  .message-box-left {
  }

  .message-box-right {
  }

  .content-detail {
    text-align: center;
    margin-top: -0.95rem !important;
    p {
      margin-bottom: 0;
    }
  }

  .content-message {
    // padding: 1em;
    background: gray;
    color: white;
    border-radius: 12px;
    // padding: 0.5rem;
    // padding-left: 1rem;
    // padding-right: 1rem;
    padding: 5px 25px;
    text-align: center;
    white-space: break-spaces;
  }
}

//.operator-message-box {
//  align-self: flex-end;
//  display: flex;
//  .content {
//  }
//  .detail {
//  }
//  .message {
//    background: #8d5185;
//    color:white
//  }
//}
</style>
